import { render, staticRenderFns } from "./MovementsDialog.vue?vue&type=template&id=31734ffd"
import script from "./MovementsDialog.vue?vue&type=script&lang=js"
export * from "./MovementsDialog.vue?vue&type=script&lang=js"
import style0 from "./MovementsDialog.vue?vue&type=style&index=0&id=31734ffd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports